import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useCoreApi } from '../api';

export const useDeleteUserImage = () => {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const deleteAccount = async (userId?: string) => {
    const { data } = await CoreApi.delete(`/logos/users/${userId}`);
    return data;
  };

  return useMutation({
    mutationFn: deleteAccount,
    onSuccess() {
      void queryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
  });
};

export const useDeleteUserAccount = () => {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const deleteAccount = async () => {
    const { data } = await CoreApi.delete(`/users`);
    return data;
  };

  return useMutation({
    mutationFn: deleteAccount,
    onSuccess() {
      void queryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
  });
};
